import { AiCoachOverview } from '../models/virtual-ai-coach';
import { createReducer, on } from '@ngrx/store';
import { virtualCoachActions } from './virtual-coach.actions';
import { FbVirtualCoach } from '../models/virtual-coach.model';

export interface VirtualCoachState {
  aiCoachOverview?: AiCoachOverview;
  aiCoachPlan?: FbVirtualCoach;
}

export const initialState: VirtualCoachState = {
  aiCoachOverview: undefined,
  aiCoachPlan: undefined,
};

export const virtualCoachReducer = createReducer(
  initialState,
  on(
    virtualCoachActions.loadOverview,
    virtualCoachActions.updatePersonalData,
    (state): VirtualCoachState => ({ ...state })
  ),
  on(
    virtualCoachActions.loadOverviewSuccess,
    virtualCoachActions.updatePersonalDataSuccess,
    (state, { aiCoachOverview }): VirtualCoachState => ({ ...state, aiCoachOverview })
  ),
  on(
    virtualCoachActions.updateAICoachPlanSuccess,
    (state, { aiCoachPlan }): VirtualCoachState => ({ ...state, aiCoachPlan })
  )
);
